import { adminConsoleMessages, appRoutes, customerServiceMessages, fiduciarieMessages, homeMessages } from 'azshared';
import { MessageDescriptor } from 'react-intl';

export interface BreadcrumbItem {
  key: string;
  label: MessageDescriptor;
  path: string;
}

export const mapBreadcrumb: { [key: string]: BreadcrumbItem } = {
  home: { key: 'home', label: homeMessages.menuItemHome, path: appRoutes.Dashboard },
  wallet: { key: 'wallet', label: homeMessages.menuItemWallet, path: appRoutes.Wallet },
  sign: { key: 'sign', label: homeMessages.menuItemSign, path: appRoutes.Sign },
  documents: { key: 'documents', label: homeMessages.menuItemDocuments, path: appRoutes.Documents },
  'for-you': { key: 'for-you', label: homeMessages.menuItemForYou, path: appRoutes.ForYou },
  news: { key: 'news', label: homeMessages.menuItemNews, path: appRoutes.News },
  faqs: { key: 'faqs', label: homeMessages.menuItemFaq, path: appRoutes.Faqs },
  'profile-page': { key: 'profile-page', label: homeMessages.menuItemPersonalArea, path: appRoutes.ProfilePage },
  dashboard: { key: 'dashboard', label: adminConsoleMessages.menuItemDashboard, path: appRoutes.AdminDashboard },
  'customer-service': { key: 'customer-service', label: customerServiceMessages.breadcrumbClientSupport, path: appRoutes.CustomerService },
  'gestione-fiduciarie': { key: 'gestione-fiduciarie', label: adminConsoleMessages.menuItemFiduciarie, path: appRoutes.AdminFiduciarie },
  creazione: { key: 'creazione', label: fiduciarieMessages.breadcrumbCreate, path: appRoutes.AdminFiduciarieCreate },
  er: { key: 'er', label: homeMessages.breadcrumbEr, path: appRoutes.WalletEr },
  detail: { key: 'detail', label: homeMessages.breadcrumbDetail, path: appRoutes.WalletErDetail }
};
